<script lang="ts" setup>
const { t } = useL10n()
const languageSelectionStore = useLanguageSelectionStore()
</script>

<template>
  <Dialog
    v-model:visible="languageSelectionStore.languageDialog"
    :header="t('global.mainMenu.changeLanguage')"
    modal
    :style="{ width: '25rem' }"
  >
    <div class="flex flex-col gap-4">
      <div class="flex align-items-center gap-2">
        <label for="language" class="font-semibold w-6rem">
          {{ t('components.languageSelectionDialog.language') }}</label
        >
        <Dropdown
          id="language"
          v-model="languageSelectionStore.selectedLanguage"
          :options="languageSelectionStore.languages"
          option-label="name"
          option-value="code"
          placeholder="Sprache auswählen"
          class="w-full"
        >
          <template #value="slotProps">
            <div v-if="slotProps.value" class="flex align-items-center gap-2">
              <i
                :class="
                  languageSelectionStore.languages.find((l) => l.code === slotProps.value)?.flag
                "
              ></i>
              <span>{{
                languageSelectionStore.languages.find((l) => l.code === slotProps.value)?.name
              }}</span>
            </div>
            <span v-else>{{ slotProps.placeholder }}</span>
          </template>
          <template #option="slotProps">
            <div class="flex align-items-center gap-2">
              <i :class="slotProps.option.flag"></i>
              <span>{{ slotProps.option.name }}</span>
            </div>
          </template>
        </Dropdown>
      </div>
    </div>
    <template #footer>
      <Button
        :label="t('global.back')"
        text
        @click="languageSelectionStore.languageDialog = false"
      />
      <Button
        :label="t('global.submit')"
        autofocus
        @click="languageSelectionStore.changeLanguage"
      />
    </template>
  </Dialog>
</template>

<style></style>
